import {
	AppBar,
	Button,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Toolbar,
} from '@mui/material';
import React from 'react';

import {BookingScriptFlowEnum} from 'main/analytics/gaTagsEnum';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useScriptModal} from './hooks/useScriptModal';
import {StyledDialog, StyledDialogActions, StyledStack} from './styles';
import {ScriptModalProps} from './types';

const {headerTitle, title, description, content, button1, button2} =
	translations['pt-br'].privateFlow.bookingFlow.scriptModal;

export function ScriptModal({open, setOpen, handleNext}: ScriptModalProps) {
	const {handleClose, handleCallChat, bookingData, theme} = useScriptModal({setOpen});

	return (
		<StyledDialog
			open={open}
			onClose={handleClose}
			data-tag-id={BookingScriptFlowEnum.VISUALIZOU_SUGESTAO_AGENDAMENTO}>
			<AppBar elevation={0} position="relative">
				<Toolbar disableGutters>
					<DialogTitle variant="h6" sx={{flex: 1}}>
						{headerTitle}
					</DialogTitle>

					<IconButton
						onClick={handleClose}
						style={{marginRight: 4}}
						aria-label="close"
						color="inherit"
						size="large"
						data-tag-id={BookingScriptFlowEnum.CLICK_FECHAR_AGENDAMENTO_SUGERIDO}>
						<Icon name="close-filled" color={theme.palette.other.closeIcon} />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent sx={{p: 3}}>
				<DialogTitle
					textAlign="center"
					sx={{
						p: 0,
						mb: 2,
					}}>
					{title} <br />
					{formatText(bookingData.specialtyName)}
				</DialogTitle>

				<DialogContentText mb={3} textAlign="center" color="text.primary">
					{content} {formatText(bookingData.specialtyName)}.
				</DialogContentText>
				<DialogContentText textAlign="center" color="text.primary">
					{description}
				</DialogContentText>
			</DialogContent>
			<StyledDialogActions>
				<StyledStack>
					<Button
						fullWidth
						size="large"
						onClick={handleNext}
						data-tag-id={BookingScriptFlowEnum.CLICK_PROSSEGUIR_COM_SUGESTAO}>
						{button1}
					</Button>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						onClick={handleCallChat}
						data-tag-id={BookingScriptFlowEnum.CLICK_INICIAR_CHAT_SUGESTAO_AGENDAMENTO}>
						{button2}
					</Button>
				</StyledStack>
			</StyledDialogActions>
		</StyledDialog>
	);
}
